import { Injectable } from '@angular/core';
import { RequestLibraryService } from '@service/core/request-library.service';

@Injectable()
export class EmailVariantsService {
  constructor(private requestLibrary: RequestLibraryService) {}

  list(automationId: number, actionId: number) {
    return this.requestLibrary.Get(
      '/automations/' + automationId + '/actions/' + actionId + '/email-variants'
    );
  }

  create(automationId: number, actionId: number, data: any) {
    return this.requestLibrary.Post(
      '/automations/' + automationId + '/actions/' + actionId + '/email-variants',
      data
    );
  }

  update(automationId: number, actionId: number, variantId: string, data: any) {
    return this.requestLibrary.Put(
      '/automations/' + automationId + '/actions/' + actionId + '/email-variants/' + variantId,
      data
    );
  }

  delete(automationId: number, actionId: number, variantId: string) {
    return this.requestLibrary.Delete(
      '/automations/' + automationId + '/actions/' + actionId + '/email-variants/' + variantId
    );
  }

  enable(automationId: number, actionId: number, variantId: string) {
    return this.requestLibrary.Post(
      '/automations/' + automationId + '/actions/' + actionId + '/email-variants/' + variantId + '/enable',
      {}
    );
  }

  disable(automationId: number, actionId: number, variantId: string) {
    return this.requestLibrary.Post(
      '/automations/' + automationId + '/actions/' + actionId + '/email-variants/' + variantId + '/disable',
      {}
    );
  }

  abStats(automationId: number, actionId: number, options: any = {}) {
    return this.requestLibrary.GetAll(
      '/automations/' + automationId + '/actions/' + actionId + '/ab-stats',
      { options }
    );
  }
}
